export const DSMobileBannerName = 'DSMobileBanner';
